<template>
  <div class="row">
    <div class="col-md-12">
      <dashboard-box :title="$t('offers.edit_offer')">
        <template v-slot:preview>
          <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <b-row>
              <b-col xl="12">
                <b-form-group
                    :label="$t('new_offer.project_name_')"
                    :description="$t('new_offer.project_name_description')"
                >
                  <b-input-group>
                    <b-form-input
                        class="form-control form-control-solid"
                        v-model="form.name"
                        type="text"
                        required
                        :disabled="form.name_status"
                        :placeholder="$t('new_offer.project_name')"
                    ></b-form-input>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'name_status')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>

                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col xl="4">
                <b-form-group id="input-group-3" :label="$t('new_offer.offer_owner_')" label-for="input-3">
                  <b-input-group>
                    <b-form-select
                        v-model="form.owner"
                        :options="owners"
                        :disabled="form.owner_status"
                    ></b-form-select>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'owner_status')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col xl="4">
                <b-form-group id="input-group-20" label="Anket Türü" label-for="input-20">
                  <b-input-group>
                    <b-form-select
                        v-model="form.survey_type"
                        :options="survey_types"
                        :disabled="form.survey_types"
                    ></b-form-select>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'survey_types')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col xl="4">
                <b-form-group id="input-group-3" :label="$t('new_offer.customer_type')" label-for="input-3">
                  <b-input-group>
                    <b-form-select
                        v-model="form.customer_type"
                        :disabled="form.customer_types"
                        :options="customer_types"></b-form-select>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'customer_types')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                    <b-input-group-append>
                      <b-button v-b-modal.customer_types variant="secondary" :disabled="form.customer_types"><i class="fas fa-cog"></i></b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-modal size="xl" id="customer_types" hide-footer :title="$t('new_offer.customer_type')">
                  <b-row>
                    <b-col xl="12" class="text-right">
                      <b-button size="sm" v-b-modal.add_customer_type variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                      <b-modal size="lg" id="add_customer_type" title="Yeni Müşteri Tipi Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="12">
                            <b-form-group label="Müşteri Grubu Adı">
                              <b-form-input
                                  type="text"
                                  class="form-control form-control-solid"
                                  required
                                  placeholder="Müşteri grubu adı giriniz."
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                      <b-modal size="lg" id="edit_customer_type" title="Son Müşteri" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="12">
                            <b-form-group label="Müşteri Grubu Adı">
                              <b-form-input
                                  type="text"
                                  value="Son Müşteri"
                                  class="form-control form-control-solid"
                                  required
                                  placeholder="Müşteri grubu adı giriniz."
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                    </b-col>
                    <b-col xl="12">
                      <data-table
                          :items="table.customer_type"
                          :fields="report.customer_type_fields"
                          :paginate="report.paginate"
                          page.sync="3"
                          perPage.sync="10"
                      ></data-table>
                    </b-col>
                  </b-row>
                </b-modal>
              </b-col>
              <b-col xl="4">
                <b-form-group id="input-group-6" :label="$t('new_offer.contact_')" label-for="input-5">
                  <b-input-group>
                    <b-form-select
                        v-model="form.contact_id"
                        :options="contacts"
                        :disabled="form.contact_status"
                    ></b-form-select>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'contact_status')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                    <b-input-group-append>
                      <b-button v-b-modal.contacts variant="secondary" :disabled="form.contact_status"><i class="fas fa-cog"></i></b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-modal size="xl" id="contacts" hide-footer :title="$t('new_offer.contact')">
                  <b-row>
                    <b-col xl="12" class="text-right">
                      <b-button size="sm" v-b-modal.add_contact variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                      <b-modal size="lg" id="add_contact" title="Yeni Kontak Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="12">
                            <b-form-group :label="$t('new_offer.customer_')" label-for="input-group-4" id="input-group-4">
                              <b-form-select
                                  id="input-group-4"
                                  class="form-control form-control-solid"
                                  v-model="form.customer_id"
                                  :options="customers"
                              ></b-form-select>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Ünvan">
                              <b-form-input
                                  class="form-control form-control-solid"
                                  type="text"
                                  placeholder="Ünvan giriniz."
                              >
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Ad Soyad">
                              <b-form-input
                                  class="form-control form-control-solid"
                                  type="text"
                                  placeholder="Ad Soyad giriniz."
                              >
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="E-Posta">
                              <b-form-input
                                  class="form-control form-control-solid"
                                  type="text"
                                  placeholder="E-Posta giriniz."
                              >
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Telefon">
                              <b-form-input
                                  class="form-control form-control-solid"
                                  type="text"
                                  placeholder="Telefon numarası giriniz."
                              >
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                      <b-modal size="lg" id="edit_contact" title="Kaya Petek" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="12">
                            <b-form-group :label="$t('new_offer.customer_')" label-for="input-group-4" id="input-group-4">
                              <b-form-select
                                  id="input-group-4"
                                  class="form-control form-control-solid"
                                  v-model="form.customer_id"
                                  :options="customers"
                              ></b-form-select>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Ünvan">
                              <b-form-input
                                  class="form-control form-control-solid"
                                  type="text"
                                  value="Müşavir"
                                  placeholder="Ünvan giriniz."
                              >
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Ad Soyad">
                              <b-form-input
                                  value="Kaya Petek"
                                  class="form-control form-control-solid"
                                  type="text"
                                  placeholder="Ad Soyad giriniz."
                              >
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="E-Posta">
                              <b-form-input
                                  value="kaya_petek@gmail.com"
                                  class="form-control form-control-solid"
                                  type="text"
                                  placeholder="E-Posta giriniz."
                              >
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Telefon">
                              <b-form-input
                                  value="0555 555 55 55"
                                  class="form-control form-control-solid"
                                  type="text"
                                  placeholder="Telefon numarası giriniz."
                              >
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                    </b-col>
                    <b-col xl="12">
                      <data-table
                          :items="table.contacts"
                          :fields="report.contact_fields"
                          :paginate="report.paginate"
                          page.sync="3"
                          perPage.sync="10"
                      ></data-table>
                    </b-col>
                  </b-row>
                </b-modal>
              </b-col>
              <b-col xl="4">
                <b-form-group :label="$t('new_offer.customer_')" label-for="input-group-4" id="input-group-4">
                  <b-input-group>
                    <b-form-select
                        id="input-group-4"
                        v-model="form.customer_id"
                        :options="customers"
                        :disabled="form.customer_status"
                    ></b-form-select>
                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'customer_status')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                    <b-input-group-append>
                      <b-button v-b-modal.customers variant="secondary" :disabled="form.customer_status"><i class="fas fa-cog"></i></b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-modal size="xl" id="customers" hide-footer title="Müşteriler">
                  <b-row>
                    <b-col xl="12" class="text-right">
                      <b-button size="sm" v-b-modal.add_customer variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                      <b-modal size="lg" id="add_customer" title="Yeni Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="6">
                            <b-form-group label="Ad Soyad">
                              <b-form-input
                                  class="form-control form-control-solid"
                                  type="text"
                                  placeholder="Ad Soyad giriniz."
                              >
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Ürün Tipi">
                              <b-form-select
                                  class="form-control form-control-solid"
                                  v-model="form.product_type"
                                  :options="product_types"
                              ></b-form-select>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Varsayılan Para Birimi">
                              <b-form-select
                                  class="form-control form-control-solid"
                                  :value="$t('general.select')"
                                  :options="[$t('general.select'),'TL','EUR','USD']"
                              ></b-form-select>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Vergi Muafiyeti">
                              <b-form-select
                                  class="form-control form-control-solid"
                                  :value="$t('general.select')"
                                  :options="[$t('general.select'),'Muaf','Muaf Değil']"
                              ></b-form-select>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Fatura Ayrıntıları">
                              <b-form-select
                                  class="form-control form-control-solid"
                                  :value="$t('general.select')"
                                  :options="[$t('general.select'),'Dahil','Hariç']"
                              ></b-form-select>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                      <b-modal size="lg" id="edit_customer" title="Ali Sayar" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="6">
                            <b-form-group label="Ad Soyad">
                              <b-form-input
                                  class="form-control form-control-solid"
                                  type="text"
                                  value="Ali Sayar"
                                  placeholder="Ad Soyad giriniz."
                              >
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Ürün Tipi">
                              <b-form-select
                                  class="form-control form-control-solid"
                                  v-model="form.product_type"
                                  :options="product_types"
                              ></b-form-select>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Varsayılan Para Birimi">
                              <b-form-select
                                  class="form-control form-control-solid"
                                  value="TL"
                                  :options="[$t('general.select'),'TL','EUR','USD']"
                              ></b-form-select>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Vergi Muafiyeti">
                              <b-form-select
                                  class="form-control form-control-solid"
                                  value="Muaf"
                                  :options="[$t('general.select'),'Muaf','Muaf Değil']"
                              ></b-form-select>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Fatura Ayrıntıları">
                              <b-form-select
                                  class="form-control form-control-solid"
                                  value="Hariç"
                                  :options="[$t('general.select'),'Dahil','Hariç']"
                              ></b-form-select>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                    </b-col>
                    <b-col xl="12">
                      <data-table
                          :items="table.customers"
                          :fields="report.customer_fields"
                          :paginate="report.paginate"
                          page.sync="3"
                          perPage.sync="10"
                      ></data-table>
                    </b-col>
                  </b-row>
                </b-modal>
              </b-col>
              <b-col xl="4">
                <b-form-group :label="$t('new_offer.sector_')" label-for="input-3">
                  <b-input-group>
                    <b-form-select
                        v-model="form.sector_id"
                        :options="sectors"
                        :disabled="form.sector_status"
                    ></b-form-select>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'sector_status')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                    <b-input-group-append>
                      <b-button v-b-modal.sectors variant="secondary" :disabled="form.sector_status"><i class="fas fa-cog"></i></b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-modal size="xl" id="sectors" hide-footer :title="$t('new_offer.sector')">
                  <b-row>
                    <b-col xl="12" class="text-right">
                      <b-button size="sm" v-b-modal.add_sector variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                      <b-modal size="lg" id="add_sector" title="Yeni Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="12">
                            <b-form-group label="Sektör Adı">
                              <b-form-input
                                  type="text"
                                  class="form-control form-control-solid"
                                  required
                                  placeholder="Sektör adı giriniz."
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                      <b-modal size="lg" id="edit_sector" title="Gıda" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="12">
                            <b-form-group label="Sektör Adı">
                              <b-form-input
                                  type="text"
                                  value="Gıda"
                                  class="form-control form-control-solid"
                                  required
                                  placeholder="Sektör adı giriniz."
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                    </b-col>
                    <b-col xl="12">
                      <data-table
                          :items="table.sectors"
                          :fields="report.sector_fields"
                          :paginate="report.paginate"
                          page.sync="3"
                          perPage.sync="10"
                      ></data-table>
                    </b-col>
                  </b-row>
                </b-modal>
              </b-col>
              <b-col xl="4">
                <b-form-group id="input-group-4" :label="$t('new_offer.country_')" label-for="input-3">
                  <b-input-group>
                    <b-form-select
                        v-model="form.country_id"
                        :options="countries"
                        :disabled="form.country_status"
                    ></b-form-select>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'country_status')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>

                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col xl="4">
                <b-form-group :label="$t('new_offer.project_type')" label-for="input-3">
                  <b-input-group>
                    <b-form-select
                        v-model="form.project_type_id"
                        :options="project_types"
                        :disabled="form.project_types"
                    ></b-form-select>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'project_types')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                    <b-input-group-append>
                      <b-button v-b-modal.project_types variant="secondary" :disabled="form.project_types"><i class="fas fa-cog"></i></b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-modal size="xl" id="project_types" hide-footer :title="$t('new_offer.project_type')">
                  <b-row>
                    <b-col xl="12" class="text-right">
                      <b-button size="sm" v-b-modal.add_project_type variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                      <b-modal size="lg" id="add_project_type" title="Yeni Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="12">
                            <b-form-group label="Proje Tipi">
                              <b-form-input
                                  type="text"
                                  class="form-control form-control-solid"
                                  required
                                  placeholder="Proje tipi giriniz."
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                      <b-modal size="lg" id="edit_project_type" title="Online Panel" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="12">
                            <b-form-group label="Proje Tipi">
                              <b-form-input
                                  type="text"
                                  value="Online Panel"
                                  class="form-control form-control-solid"
                                  required
                                  placeholder="Proje tipi giriniz."
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                    </b-col>
                    <b-col xl="12">
                      <data-table
                          :items="table.project_types"
                          :fields="report.project_type_fields"
                          :paginate="report.paginate"
                          page.sync="3"
                          perPage.sync="10"
                      ></data-table>
                    </b-col>
                  </b-row>
                </b-modal>
              </b-col>
              <b-col xl="4">
                <b-form-group id="input-group-5" :label="$t('new_offer.research_')" label-for="input-3">
                  <b-input-group>
                    <b-form-select
                        v-model="form.research_id"
                        :options="researches"
                        :disabled="form.research_status"
                    ></b-form-select>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'research_status')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                    <b-input-group-append>
                      <b-button v-b-modal.researches variant="secondary" :disabled="form.research_status"><i class="fas fa-cog"></i></b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-modal size="xl" id="researches" hide-footer :title="$t('new_offer.researchs')">
                  <b-row>
                    <b-col xl="12" class="text-right">
                      <b-button size="sm" v-b-modal.add_research_type variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                      <b-modal size="lg" id="add_research_type" title="Yeni Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="12">
                            <b-form-group label="Araştırma Tipi Adı">
                              <b-form-input
                                  type="text"
                                  class="form-control form-control-solid"
                                  required
                                  placeholder="Araştırma Tipi adı giriniz."
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                      <b-modal size="lg" id="edit_research_type" title="Gündem Araştırması" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="12">
                            <b-form-group label="Araştırma Tipi Adı">
                              <b-form-input
                                  type="text"
                                  value="Gündem Araştırması"
                                  class="form-control form-control-solid"
                                  required
                                  placeholder="Araştırma tipi adı giriniz."
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                    </b-col>
                    <b-col xl="12">
                      <data-table
                          :items="table.research_types"
                          :fields="report.research_type_fields"
                          :paginate="report.paginate"
                          page.sync="3"
                          perPage.sync="10"
                      ></data-table>
                    </b-col>
                  </b-row>
                </b-modal>
              </b-col>
              <b-col xl="4">
                <b-form-group :label="$t('new_offer.things_to_do')" label-for="input-3">
                  <b-input-group>
                    <b-form-select
                        v-model="form.things_to_do_id"
                        :options="things_to_do"
                        :disabled="form.things_to_do"
                    ></b-form-select>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'things_to_do')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                    <b-input-group-append>
                      <b-button v-b-modal.things_to_dos variant="secondary" :disabled="form.things_to_do"><i class="fas fa-cog"></i></b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-modal size="xl" id="things_to_dos" hide-footer :title="$t('new_offer.things_to_do')">
                  <b-row>
                    <b-col xl="12" class="text-right">
                      <b-button size="sm" v-b-modal.add_things_to_do variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                      <b-modal size="lg" id="add_things_to_do" title="Yeni Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="12">
                            <b-form-group label="Yapılacak Adı">
                              <b-form-input
                                  type="text"
                                  class="form-control form-control-solid"
                                  required
                                  placeholder="Yapılacak adı giriniz."
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                      <b-modal size="lg" id="edit_things_to_do" title="Saha" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="12">
                            <b-form-group label="Yapılacak Adı">
                              <b-form-input
                                  type="text"
                                  value="Saha"
                                  class="form-control form-control-solid"
                                  required
                                  placeholder="Yapılacak adı giriniz."
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                    </b-col>
                    <b-col xl="12">
                      <data-table
                          :items="table.things_to_dos"
                          :fields="report.things_to_do_fields"
                          :paginate="report.paginate"
                          page.sync="3"
                          perPage.sync="10"
                      ></data-table>
                    </b-col>
                  </b-row>
                </b-modal>
              </b-col>
              <b-col xl="4">
                <b-form-group :label="$t('new_offer.product_type')" label-for="input-3">
                  <b-input-group>
                    <b-form-select
                        v-model="form.product_type_id"
                        :options="product_types"
                        :disabled="form.product_types"
                    ></b-form-select>
                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'product_types')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                    <b-input-group-append>
                      <b-button v-b-modal.product_types variant="secondary" :disabled="form.product_types"><i class="fas fa-cog"></i></b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-modal size="xl" id="product_types" hide-footer :title="$t('new_offer.product_type')">
                  <b-row>
                    <b-col xl="12" class="text-right">
                      <b-button size="sm" v-b-modal.add_product_type variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                      <b-modal size="lg" id="add_product_type" title="Yeni Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="12">
                            <b-form-group label="Ürün Tipi Adı">
                              <b-form-input
                                  type="text"
                                  class="form-control form-control-solid"
                                  required
                                  placeholder="Ürün tipi adı giriniz."
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                      <b-modal size="lg" id="edit_product_type" title="Kantitatif Tracking" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="12">
                            <b-form-group label="Ürün Tipi Adı">
                              <b-form-input
                                  type="text"
                                  value="Kantitatif Tracking"
                                  class="form-control form-control-solid"
                                  required
                                  placeholder="Ürün tipi adı giriniz."
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                    </b-col>
                    <b-col xl="12">
                      <data-table
                          :items="table.product_types"
                          :fields="report.product_type_fields"
                          :paginate="report.paginate"
                          page.sync="3"
                          perPage.sync="10"
                      ></data-table>
                    </b-col>
                  </b-row>
                </b-modal>
              </b-col>
              <b-col xl="4">
                <b-form-group :label="$t('new_offer.wave')" label-for="input-3">
                  <b-input-group>
                    <b-form-select
                        v-model="form.wave_id"
                        :options="waves"
                        :disabled="form.wave"
                    ></b-form-select>
                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                      {{$t('new_offer.show_offer')}}
                    </b-input-group-prepend>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'wave')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col xl="4">
                <b-form-group :label="$t('new_offer.project_status')" label-for="input-3">
                  <b-input-group>
                    <b-form-select
                        v-model="form.project_status_id"
                        :options="project_status"
                        :disabled="form.project_status"
                    ></b-form-select>
                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'project_status')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                    <b-input-group-append>
                      <b-button v-b-modal.project_status variant="secondary" :disabled="form.project_status"><i class="fas fa-cog"></i></b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-modal size="xl" id="project_status" hide-footer :title="$t('new_offer.project_status')">
                  <b-row>
                    <b-col xl="12" class="text-right">
                      <b-button size="sm" v-b-modal.add_project_status variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                      <b-modal size="lg" id="add_project_status" title="Yeni Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="6">
                            <b-form-group label="Durum Adı">
                              <b-form-input
                                  type="text"
                                  class="form-control form-control-solid"
                                  required
                                  placeholder="Durum adı giriniz."
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Durum Kısa Adı">
                              <b-form-input
                                  type="text"
                                  class="form-control form-control-solid"
                                  required
                                  placeholder="Durum için kısa bir ad giriniz."
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Grup Seçiniz">
                              <b-form-select
                                  class="form-control form-control-solid"
                                  :value="$t('general.select')"
                                  :options="[$t('general.select'),'Teklif Kartı', 'Wave']"
                              ></b-form-select>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                      <b-modal size="lg" id="edit_project_status" title="Onaylandı" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                        <b-row>
                          <b-col xl="6">
                            <b-form-group label="Durum Adı">
                              <b-form-input
                                  type="text"
                                  class="form-control form-control-solid"
                                  required
                                  value="Onaylandı"
                                  placeholder="Durum adı giriniz."
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Durum Kısa Adı">
                              <b-form-input
                                  type="text"
                                  class="form-control form-control-solid"
                                  required
                                  value="CNF"
                                  placeholder="Durum için kısa bir ad giriniz."
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col xl="6">
                            <b-form-group label="Grup Seçiniz">
                              <b-form-select
                                  class="form-control form-control-solid"
                                  value="Teklif Kartı"
                                  :options="[$t('general.select'),'Teklif Kartı', 'Wave']"
                              ></b-form-select>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-modal>
                    </b-col>
                    <b-col xl="12">
                      <data-table
                          :items="table.project_status"
                          :fields="report.project_status_fields"
                          :paginate="report.paginate"
                          page.sync="3"
                          perPage.sync="10"
                      ></data-table>
                    </b-col>
                  </b-row>
                </b-modal>
              </b-col>
              <b-col xl="4">
                  <b-form-group :label="$t('new_offer.potential_for_sale')">
                    <b-input-group append="%">
                      <b-input
                          class="form-control form-control-solid"
                          :placeholder="$t('new_offer.potential_for_sale')"
                          type="number"
                          v-model="form.potential_for_sale_id"
                          :disabled="form.potential_for_sale"
                      ></b-input>
                      <b-input-group-prepend is-text>
                        <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'potential_for_sale')">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                      </b-input-group-prepend>
                    </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="separator separator-dashed mb-6"></div>
            <h3 class="font-size-lg text-dark font-weight-bold mb-6">{{ $t('new_offer.information') }}</h3>
            <b-row>
              <b-col xl="4">
                <b-form-group :label="$t('new_offer.order_date_')" label-for="input-2">
                  <b-input-group>
                    <b-form-input
                        v-model="form.date"
                        type="date"
                        required
                        :placeholder="$t('new_offer.order_date')"
                        :disabled="form.date_status"
                    ></b-form-input>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'date_status')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>

                  </b-input-group>

                </b-form-group>
              </b-col>
              <b-col xl="4">
                <b-form-group id="ir_form_group" :label="$t('new_offer.ir')" label-for="input-3">
                  <b-input-group append="%">
                    <b-input
                        v-model="form.ir"
                        class="form-control form-control-solid"
                        :placeholder="$t('new_offer.ir')"
                        type="number"
                        :disabled="form.ir_options"
                    ></b-input>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'ir_options')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form-group>
                <b-tooltip target="ir_form_group">
                  Kolay > %80 <hr> %80 > Orta > %40 <hr> 39% < Zor
                </b-tooltip>
              </b-col>
              <b-col xl="4">
                <b-form-group :label="$t('new_offer.loi')" label-for="input-3">
                  <b-input-group append="dk">
                    <b-input
                        v-model="form.loi"
                        class="form-control form-control-solid"
                        :placeholder="$t('new_offer.loi')"
                        type="number"
                        :disabled="form.loi_options"
                    ></b-input>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'loi_options')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="separator separator-dashed mb-6"></div>
            <h3 class="font-size-lg text-dark font-weight-bold mb-6">{{ $t('new_offer.field_information') }}</h3>
            <b-row>
              <b-col xl="4">
                <b-form-group id="input-group-5" :label="$t('new_offer.currency_')" label-for="input-3">

                  <b-input-group>
                    <b-form-select
                        v-model="form.currency_id"
                        :options="currencies"
                        :disabled="form.currency_status"
                    ></b-form-select>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'currency_status')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                  </b-input-group>

                </b-form-group>
              </b-col>
              <b-col xl="4">
                <b-form-group id="input-group-5" :label="$t('new_offer.exchange_rate_')" label-for="input-3">
                  <b-input-group>
                    <b-form-input
                        v-model="form.exchange_rate"
                        type="text"
                        required
                        disabled
                    ></b-form-input>

                    <b-input-group-append>
                      <b-button variant="outline-secondary"><i class="fa-eye fa"></i>{{ $t('new_offer.learn') }}</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col xl="4">
                <b-form-group id="sample_description" :label="$t('new_offer.sample')" label-for="input-1">
                  <b-input-group>
                    <b-form-input
                        v-model="form.sample"
                        type="text"
                        class="form-control form-control-solid"
                        :placeholder="$t('new_offer.sample')"
                        :disabled="form.sample_status"
                    ></b-form-input>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'sample_status')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form-group>
                <b-tooltip target="sample_description">
                  Wave başına örneklem sayısı
                </b-tooltip>
              </b-col>
              <b-col xl="4">
                <b-form-group :label="$t('new_offer.unit_price')" label-for="input-1">
                  <b-input-group>
                    <b-form-input
                        v-model="form.unit_price"
                        :disabled="form.unit_price_status"
                        type="text"
                        class="form-control form-control-solid"
                        :placeholder="$t('new_offer.unit_price')"
                    ></b-form-input>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'unit_price_status')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col xl="4">
                <b-form-group id="total_price_description" :label="$t('new_offer.total_price')" label-for="input-1">
                  <b-input-group>
                    <b-form-input
                        v-model="form.total_price"
                        type="text"
                        class="form-control form-control-solid"
                        :placeholder="$t('new_offer.total_price')"
                        disabled
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
                <b-tooltip target="total_price_description">
                  <strong>Örneklem</strong> x <strong>Birim Fiyatı</strong>
                </b-tooltip>
              </b-col>
              <b-col xl="4">
                <b-form-group id="general_price_description" :label="$t('new_offer.general_price')" label-for="input-1">
                  <b-input-group>
                    <b-form-input
                        v-model="form.general_price"
                        type="text"
                        class="form-control form-control-solid"
                        :placeholder="$t('new_offer.general_price')"
                        disabled
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
                <b-tooltip target="general_price_description">
                  <strong>Toplam Fiyat</strong> x <strong>Wave Sayısı</strong>
                </b-tooltip>
              </b-col>
            </b-row>
            <hr class="mb-5">
            <b-row>
              <b-col xl="12" class="mb-5">
                <b-form-group>
                  <b-input-group>
                    <b-form-textarea id="textarea-rows" v-model="form.note" :disabled="form.note_status" :placeholder="$t('new_offer.note')" rows="8"></b-form-textarea>

                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" @change="changeIt($event,'note_status')">
                        <span class="sr-only"></span>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </template>
        <template v-slot:foot>
          <b-button type="submit" :disabled="form.submit" variant="primary" class="fa-pull-right"><i class="fa fa-save"></i> {{ $t('general.save') }}</b-button>
        </template>
      </dashboard-box>
    </div>
  </div>

</template>
<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "editOffer",
  components: { DataTable, DashboardBox },
  methods: {
    HideModal(){
      window.alert('Tebrikler')
    },
    changeIt(data,input) {

      this.form.submit = false;
      this.$set(this.form,input,!data)

    },
    onSubmit(evt) {
      evt.preventDefault();
      var json_data = JSON.stringify(this.form)
      alert('Tebrikler!');
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.name = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  },
  data() {

    return {
      form: {
        name: 'Bilyoner 2020 Pazar Araştırması',
        name_status: true,
        owner_status: true,
        customer_status: true,
        country_status: true,
        contact_status: true,
        survey_types: true,
        research_status: true,
        date_status: true,
        sector_status: true,
        currency_status: true,
        note_status: true,
        submit: true,
        project_types: true,
        product_types: true,
        things_to_do: true,
        wave : true,
        potential_for_sale : true,
        ir_options : true,
        loi_options : true,
        sample_status : true,
        unit_price_status: true,
        total_price_status : true,
        general_price_status: true,
        ops_cost_status : true,
        customer_types : true,
        owner: 'Kaya Petek',
        date: '2020-12-15',
        customer_id: 'CarrefourSA',
        contact_id: 'Ayşe Güldirek',
        country_id: 'Türkiye',
        sector_id: 'Bilişim & Teknoloji',
        research_id: 'Marka Bilinirliği Araştırmaları',
        currency_id: 'EUR',
        exchange_rate: '1.0000',
        note: 'Test Not',
        new_customer_name : '',
        wave_id : 2,
        ir : 'Kolay > %80',
        loi : '5 dk',
        sample : '...',
        unit_price : '999',
        total_price : 1200,
        general_price : 1200,
        ops_cost : 650,
        project_status : true,
        project_type_id : 'F2F',
        project_status_id : 'Aktif',
        potential_for_sale_id : '90%',
        things_to_do_id : 'Saha',
        product_type_id : 'Kantitatif Araştırma Shopper',
        customer_type : 'Basın',
        campaign_form : {
          name: '2021 Beklentiler',
          slug: '2021-beklentiler',
          url: '2021-beklentiler',
          campaign_status : 'Test Modu',
          end_tape : 'Sarı',
          survey : 'Limonist (P12929)',
          wave : 1,
          button_text : 'Hemen Tıkla',
          button_url : '#',
          homepage_desc : 'Anasayfa Test Açıklaması',
          homepage_title : 'Anasayfa Test Başlığı',
          detail_page_title : 'Detay Sayfası Test Başlığı',
          date : '2020-12-11',
          winners_campaign: true,
          related_survey : true,
          mini_poll : true,
          mobile_view : true,
          tab1_title : "Tab 1 Test Başlığı",
          tab2_title : "Tab 2 Test Başlığı",
          tab3_title : "Tab 3 Test Başlığı",
          tab4_title : "Tab 4 Test Başlığı",
          target_group : 'SQL * ...',
        },
        survey_type : 'SSI Web Anketi'
      },
      campaign : {
        campaign_status: [{ text: this.$t('general.select'), value: null } , 'Test Modu','Aktif', 'Pasif'],
        end_tapes: [{ text: this.$t('general.select'), value: null } , 'Mavi','Sarı', 'Kırmızı'],
        surveys : [{ text: this.$t('general.select'), value: null } , 'Limonist (P12929)','Deneme (P12928)', 'Test (P12927)'],
        waves: [{ text: this.$t('general.select'), value: null } , '1','2', '3','4','5','6'],

      },
      survey_types : [
        { text: this.$t('general.select'), value: null },
        'Feedback Server Anketi',
        'Base Link\'li Anket',
        'Havuz Link\'li Anket',
        'SPSS/PASW Anketi',
        'Müşteri Listesine Anket (SPSS)',
        'SSI Web Anketi',
        'Müşteri Listesine Anket (SSI)'
      ],
      owners: [{ text: this.$t('general.select'), value: null }, 'Ali Duran', 'Kaya Petek', 'Ayşe Güldirek', 'Aysel Budak'],
      customers: [{ text: this.$t('general.select'), value: null }, 'BSH', 'BTA', 'Carat', 'Caretta İletişim', 'CarrefourSA', 'Coco Cola', 'Collective', 'Çanakçılar Seramik', 'D&R','Çiçek Sepeti'],
      contacts: [{ text: this.$t('general.select'), value: null }, 'Colin Butcher', 'Kaya Petek', 'Ayşe Güldirek', 'Aysel Budak'],
      countries: [{ text: this.$t('general.select'), value: null }, 'Türkiye', 'Almanya', 'Çin', 'Hindistan'],
      sectors: [{ text: this.$t('general.select'), value: null }, 'Gıda', 'Bilişim & Teknoloji', 'Giyim'],
      researches: [{ text: this.$t('general.select'), value: null }, 'Fiyatlama / Conjoint Araştırmaları', 'Gündem Araştırması', 'Marka Bilinirliği Araştırmaları', 'Marka Değeri / Marka İmaj / Konumlandırma', 'Memnuniyet Araştırmaları', 'Napolyon CRM Mini Anket', 'Reklam - Kampanya Testi'],
      currencies: [{ text: this.$t('general.select'), value: null }, 'TRY', 'USD', 'EUR'],
      show: true,
      project_types : [{ text: this.$t('general.select'), value: null }, 'Online Panel','F2F','CATI','Kalitatif','CAWI','Exit Survey'],
      product_types : [
        { text: this.$t('general.select'), value: null },
        'Kantitatif Araştırma Fiyat Analizleri',
        'Kantitatif Tracking',
        'Kantitatif Araştırma Memnuniyet-NPS Araştırmaları',
        'Kantitatif Araştırma Gizli Müşteri Araştırmaları',
        'Kantitatif Araştırma Shopper',
        'Kantitatif Araştırma Profil ve Segmentasyon Araştırmaları',
        'Kantitatif Araştırma Reklam Ön Testi Araştırmaları (Pre-Test)',
        'Kantitatif Araştırma Reklam Sonrası  Testi Araştırmaları(Post-Test)',
        'Kantitatif Araştırma Sosyal Araştırmalar',
        'Kantitatif Araştırma Tutum ve Davranış Araştırmaları - U&A',
        'Kantitatif Araştırma Konsept Ürün Fikir Testi',
        'Kantitatif Araştırma Konsept Fikir Testi',
        'Kantitatif Araştırma Ambalaj Testi Araştırmaları',
        'Kantitatif Araştırma İsim Testi Araştırmaları',
        'Kantitatif Araştırma Tat Testi',
        'Data Teslimi',
        'Script + Data Teslimi',
        'Script + Data Teslimi + Tablo',
        'Kalitatif Tracking',
        'Kalitatif Araştırma Memnuniyet-NPS Araştırmaları',
        'Kalitatif Araştırma Gizli Müşteri Araştırmaları',
        'Kalitatif Araştırma Shopper',
        'Kalitatif Araştırma Profil ve Segmentasyon Araştırmaları',
        'Kalitatif Araştırma Reklam Ön Testi Araştırmaları (Pre-Test)',
        'Kalitatif Araştırma Reklam Sonrası  Testi Araştırmaları(Post-Test)',
        'Kalitatif Araştırma Sosyal Araştırmalar',
        'Kalitatif Araştırma Tutum ve Davranış Araştırmaları',
        'Kalitatif Araştırma Konsept Ürün Fikir Testi',
        'Kalitatif Araştırma Konsept Fikir Testi',
        'Kalitatif Araştırma Ambalaj Testi Araştırmaları',
        'Kalitatif Araştırma İsim Testi Araştırmaları',
        'Kalitatif Araştırma Tat Testi',
        'Sampling - Yurtiçi',
        'Sampling - Yurtdışı',
        'Omnibus',
        'Modelleme',
        'Kurumsal İtibar',
        'Diğer',
        'Kalitatif Adhoc'
      ],
      things_to_do : [{ text: this.$t('general.select'), value: null },
        'Saha',
        'Saha + Script',
        'Script + Data Teslim',
        'Script + Tablo / Data Teslim',
        'Saha + Script + Tablo / Data Teslim',
        'Soru Formu + Script + Saha + Tablolama / Data Teslim',
        'Soru Formu + Script + Saha + Tablolama + Rapor',
        'Soru Formu + Script + Saha + Tablo / Data Teslim',
        'Soru Formu + Script + Saha + Tablolama + Rapor + Data Teslim',
        'Soru Formu + Script + Saha + Tablolama + Rapor + Sunum',
        'Script + Tablo + Rapor',
        'Denek Temini',
        'Sor Formu + Saha + Analiz Raporlama',
      ],
      waves:  [{text : this.$t('general.select'), value : null}, '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      ir_options:  [{text : this.$t('general.select'), value : null}, 'Kolay > %80', '%80 > Orta > %40', '39% < Zor'],
      loi_options:  [{text : this.$t('general.select'), value : null}, '5 dk', '10 dk', '15 dk', '20 dk', '25 dk', '30 dk'],
      project_status:  [{text : this.$t('general.select'), value : null}, 'Aktif','Onaylandı', 'Red', 'Faturası Kesildi'],
      potential_for_sale_options:  [{text : this.$t('general.select'), value : null}, '90%','50%', '25%'],
      customer_types:  [{text : this.$t('general.select'), value : null}, 'Son Müşteri','Araştırma Şirketi', 'Basın', 'Danışmanlık Şirketi', 'Halkla İlişkiler ve İletişim', 'Medya Ajansı', 'Panel Şirketi', 'Pazarlama ve Reklamcılk', 'Reklam Ajansı'],
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        customer_type_fields: [
          {key: 'name', label: 'Müşteri Tipi', sortable: false},
          {key: 'customer_type_actions', label: 'İşlem', sortable: false},
        ],
        contact_fields: [
          {key: 'name', label: 'Ad Soyad', sortable: false},
          {key: 'contact_actions', label: 'İşlem', sortable: false},
        ],
        sector_fields: [
          {key: 'name', label: 'Sektör Adı', sortable: false},
          {key: 'sector_actions', label: 'İşlem', sortable: false},
        ],
        project_type_fields: [
          {key: 'name', label: 'Proje Tipi', sortable: false},
          {key: 'project_type_actions', label: 'İşlem', sortable: false},
        ],
        research_type_fields: [
          {key: 'name', label: 'Araştırma Tipi', sortable: false},
          {key: 'research_type_actions', label: 'İşlem', sortable: false},
        ],
        things_to_do_fields: [
          {key: 'name', label: 'Araştırma Tipi', sortable: false},
          {key: 'things_to_do_actions', label: 'İşlem', sortable: false},
        ],
        product_type_fields: [
          {key: 'name', label: 'Ürün Tipi', sortable: false},
          {key: 'product_type_actions', label: 'İşlem', sortable: false},
        ],
        customer_fields: [
          {key: 'name', label: 'Ad Soyad', sortable: false},
          {key: 'customer_actions', label: 'İşlem', sortable: false},
        ],
        project_status_fields : [
          {key: 'name', label: 'Durum Adı', sortable: false},
          {key: 'shortcode', label: 'Kısa Kod', sortable: false},
          {key: 'project_status_actions', label: 'İşlem', sortable: false},
        ],
        currency_fields : [
          {key: 'name', label: 'Para Birimi', sortable: false},
          {key: 'shortcode', label: 'Kısa Kod', sortable: false},
          {key: 'currency_actions', label: 'İşlem', sortable: false},
        ]
      },
      table : {
        customer_type : [
          {'name' : 'Son Müşteri'},
          {'name' : 'Araştırma Şirketi'},
          {'name' : 'Basın'},
          {'name' : 'Danışmanlık Şirketi'},
          {'name' : 'Halkla İlişkiler ve İletişim'},
          {'name' : 'Medya Ajansı'},
          {'name' : 'Panel Şirketi'},
          {'name' : 'Pazarlama ve Reklamcılık'},
          {'name' : 'Reklam Ajansı'}
        ],
        contacts : [
          {'name' : 'Ali Sayar'},
          {'name' : 'Kaya Petek'},
          {'name' : 'Ayşegül Duran'},
          {'name' : 'Ertuğrul Duman'},
        ],
        sectors : [
          {'name' : 'Gıda'},
          {'name' : 'Bilişim & Teknoloji'},
          {'name' : 'Giyim'},
        ],
        project_types : [
          {'name' : 'Online Panel'},
          {'name' : 'F2F'},
          {'name' : 'CATI'},
          {'name' : 'Kalitatif'},
          {'name' : 'CAWI'},
          {'name' : 'Exit Survey'},
        ],
        research_types : [
          {'name' : 'Fiyatlama / Conjoint Araştırmaları'},
          {'name' : 'Gündem Araştırması'},
          {'name' : 'Marka Bilinirliği Araştırması'},
          {'name' : 'Reklam - Kampanya Testi'},
        ],
        things_to_dos : [
          {'name' : 'Saha'},
          {'name' : 'Saha + Script'},
          {'name' : 'Denek Temini'},
          {'name' : 'Script + Tablo + Rapor'},
        ],
        product_types : [
          {'name' : 'Kantitatif Tracking'},
          {'name' : 'Kantitatif Araştırma Fiyat Analizleri'},
          {'name' : 'Data Teslimi'},
          {'name' : 'Script + Data Teslimi'},
          {'name' : 'Omnibus'},
          {'name' : 'Modelleme'},
        ],
        customers : [
          {'name' : 'Ali Sayar'},
          {'name' : 'Kaya Petek'},
          {'name' : 'Ayşegül Duran'},
          {'name' : 'Ertuğrul Duman'},
        ],
        project_status : [
          {'name' : 'Onaylandı' , 'shortcode' : 'CNF'},
          {'name' : 'Aktif' , 'shortcode' : 'ACT'},
          {'name' : 'Red' , 'shortcode' : 'DSC'},
          {'name' : 'Faturası Kesildi' , 'shortcode' : 'DLV'},
        ],
        currencies : [
          {'name' : 'Türk Lirası' , 'shortcode' : 'TRY'},
          {'name' : 'Amerikan Doları' , 'shortcode' : 'USD'},
          {'name' : 'Euro' , 'shortcode' : 'EUR'},
        ],
      },
    }
  },
  mounted() {

    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('general.project_1'), route: "alert" },
      { title: "Bilyoner 2020 Pazar Araştırması" }
    ]);
  }
}
</script>

<style scoped>
.btn.btn-secondary i{
  font-size: 12px;
}
</style>
